import React, { Fragment, useState } from 'react';
import { Combobox, Transition } from '@headlessui/react';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid';


const ComboboxAutocomplete = ({ options, bgActiveColor, textActiveColor, placeholder, onChange, value=null, positionOptions, zIndex = 'z-20' }) => {
  const [query, setQuery] = useState('');

  const filteredOptions =
    query === ''
      ? options
      : options.filter((element) =>
          (element).name
            ?.toLowerCase()
            .replace(/\s+/g, '')
            .includes(query.toLowerCase().replace(/\s+/g, ''))
        );

  const filteredOptionsSorted = filteredOptions.sort((a, b) => {
    const aName = a.name || '';
    const bName = b.name || '';
    return aName.localeCompare(bName);
  });

  return (
    <div className="">
      <Combobox value={value} onChange={(selectedOption) => {
        onChange(selectedOption);
      }}>
        <div className="relative mt-1">
          <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm">
            <Combobox.Input
              className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
              displayValue={(element) => element && element.name ? element.name : ''}
              onChange={(event) => {
                const value = event.target.value;
                setQuery(value);
                if (value === '') {
                  onChange(null);
                }
              }}
              placeholder={placeholder}
            />
          <Combobox.Button className="absolute inset-0 w-full h-full cursor-pointer" />
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <ChevronUpDownIcon className="h-5 w-5 text-gray-400" />
            </div>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
            <Combobox.Options style={{zIndex: zIndex.split('-').at(-1)}} className={`${positionOptions ? positionOptions : 'absolute'} mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm ${zIndex}`}>
              {filteredOptionsSorted.length === 0 ? (
                <Combobox.Option
                  key="no-results"
                  className="relative cursor-default text-left select-none py-2 pl-6 pr-4 text-gray-700"
                  value={null}
                >
                  Nessun risultato
                </Combobox.Option>
              ) : (
              filteredOptionsSorted.length === 0 && query !== '' ? (
                <Combobox.Option
                  key="no-results"
                  className="relative cursor-default text-left select-none py-2 pl-6 pr-4 text-gray-700"
                  value={null}
                >
                  Nessun risultato
                </Combobox.Option>
              ) : (
                filteredOptionsSorted.map((element) => (
                  <Combobox.Option
                    key={(element).id}
                    className={({ active }) =>
                      `relative cursor-default text-left select-none py-2 pl-6 pr-4 ${
                        active ? `${bgActiveColor} ${textActiveColor}` : 'text-gray-900'
                      }`
                    }
                    value={element}
                  >
                    {({ selected, active }) => (
                    <>
                      <span
                        className={`block truncate pl-3 ${
                          selected ? 'font-medium' : 'font-normal'
                        }`}
                      >
                          {(element).name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? 'text-white' : 'text-indigo-800'
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                )))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  );
};

export default ComboboxAutocomplete;
